import {ref} from 'vue';

export default {
    install: (app, options) => {

        const distributors = ref([]);
        const loadDistributors = (companyId) => {
            window.lazy_axios.get(`/imports/${companyId}/companies/distributors`)
                .then((response) => {
                    if (response.data.distributors) {
                        distributors.value = response.data.distributors;
                    }
                });
        };

        app.provide('importCompanyDistributors', distributors);
        app.provide('loadImportCompanyDistributors', loadDistributors);
    },
}
